module.exports = __webpack_public_path__ + "static/16-1a1d299af47cafe0521bd26645c3045e.jpg";